<template>
  <div style="width: 344px" class="px-4 flex">
    <div class="relative">
      <UiImg
        class="w-10 h-10 rounded-sm overflow-hidden flex-shrink-0"
        :src="item.tokenLogo || require('@/assets/icons/nftnologo.avif')"
      ></UiImg>
      <UiImg
        v-if="item.selfAssets"
        class="absolute bottom-0 h-3 w-full left-1/2 transform -translate-x-1/2"
        :src="require('@/assets/icons/self_asset.avif')"
      ></UiImg>
    </div>

    <div class="ml-2">
      <div
        class="flex"
        :class="{
          'cursor-pointer': !!item.nftValuePath,
        }"
        @click="jump(item.nftValuePath)"
      >
        <div class="font-bold text-xs text-secondary-7" style="">
          {{ item.tokenName }}
        </div>
        <div
          class="flex-shrink-0"
          v-if="item.vaultStatus != undefined && item.vaultStatus != 1"
        >
          <tippy
            :content="
              item.vaultStatus == '0'
                ? 'Under analyzing'
                : 'Transactions of the project are not enough for evaluation or they are spam assets.'
            "
            placement="top"
            :arrow="false"
          >
            <img
              class="w-4 h-4 ml-2"
              :src="
                {
                  '-1': require('@/assets/icons/vault_-1.avif'),
                  0: require('@/assets/icons/vault_0.avif'),
                }[item.vaultStatus]
              "
              alt=""
            />
          </tippy>
        </div>
      </div>

      <div class="flex space-x-2">
        <div
          class="flex items-center"
          v-for="(chain, j) in item.chainList"
          :key="j"
        >
          <ChainCell :chain="chain"></ChainCell>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue';
import UiImg from '@/components/UiImg.vue';
import ChainCell from './ChainCell.vue';

const chainMap = {
  ethereum: 'ETH',
  matic: 'Polygon',
  ronin: 'Ronin',
};

const props = defineProps({
  item: Object,
  jumpPath: {
    type: Boolean,
    default: true,
  },
});

const jump = (name) => {
  if (name && props.jumpPath) {
    window.open(
      `${process.env.VUE_APP_VAULT_PATH}#/Collectables/${name}`,
      '_blank',
    );
  }
};
</script>

<style lang="scss" scoped></style>
